<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Egresos de bodegas</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button type="button" @click="crear" class="btn-success">
            <i class="fa fa-plus"></i><span>Crear</span>
          </button>
          <button type="button" @click="consultar" class="btn-info">
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card mb-2">
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <div class="form-inline">
              <label>
                <input v-model="form.tipoFechaP" type="radio" value="H" />
                <span>Hoy</span>
              </label>
              <label>
                <input v-model="form.tipoFechaP" type="radio" value="A" />
                <span>Ayer</span>
              </label>
              <label>
                <input v-model="form.tipoFechaP" type="radio" value="P" />
                <span>Personalizado</span>
              </label>
              <div class="form-field" v-show="form.tipoFechaP == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker id="desde" v-model="form.fechaDesdeP" locale="es" no-label
                    button-now-translation="Ahora" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                    label="Seleccione fecha..." />
                  <label>Desde:</label>
                </div>
              </div>
              <div class="form-field" v-show="form.tipoFechaP == 'P'">
                <div class="datepicker-field datepicker-field--stretch">
                  <VueCtkDateTimePicker id="hasta" v-model="form.fechaHastaP" locale="es" no-label
                    button-now-translation="Ahora" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                    label="Seleccione fecha..." />
                  <label>Hasta:</label>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2 select2-field--stretch"
              :class="{ 'select2--disabled': !administraTodasBodegas }">
              <div class="select2-field">
                <v-select :filterable="false" @input="inputBodega" label="descripcion" placeholder="Seleccione..."
                  :options="optionsBodegas" id="bodegas" v-model="selectedBodega"></v-select>
                <label for="bodegas">Bodega:</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field v-model="form.searchP" id="buscar" placeholder="Realice una consulta...">
                Consultar:
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6 mt-2">
            <div class="form-inline">
              <strong>Estados:</strong>
              <label for="activosParam">
                <input id="activosParam" v-model="form.estadoP" type="radio" value="A" />
                <span>Activos</span>
              </label>
              <label for="inactivosParam">
                <input id="inactivosParam" v-model="form.estadoP" type="radio" value="I" />
                <span>Inactivos</span>
              </label>
              <label for="todosParam">
                <input id="todosParam" v-model="form.estadoP" type="radio" value="T" />
                <span>Todos</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <k-table @editar="editar" @eliminar="eliminar" :createButton="false" :deleteButton="puedeAnular"
          :editButton="puedeEditar" :path="path" :params="form" :buscarButton="false" :cargarAlIniciar="false"
          ref="listaEgresos" :columns="[
            {
              display: 'Documento',
              value: 'numero_comprobante',
            },
            {
              display: 'Fecha',
              value: 'fecha_transaccion',
            },
            {
              display: 'Bodega',
              value: 'descripcion_bodega',
            },
            {
              display: 'Nota',
              value: 'nota',
            },
            {
              display: 'Estado',
              value: 'descripcion_estado',
            },
            {
              display: 'Creador',
              value: 'creador.nombre',
            },
            {
              display: 'Creación',
              value: 'created_at',
            },
            {
              display: 'Modificador',
              value: 'modificador.nombre',
            },
            {
              display: 'Modificación',
              value: 'updated_at',
            }
          ]"></k-table>
      </div>
    </div>
    <modal name="egreso-bodega" scrollable reset adaptive resizable height="auto" width="90%" :clickToClose="false">
      <egreso-bodega @guardar="$modal.hide('egreso-bodega'); consultar();" @cerrar="$modal.hide('egreso-bodega')"
        :egresoBodegaId="egresoBodegaId" :bodegas="optionsBodegas" :documento="documento"></egreso-bodega>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      required: true
    },
    puedeConsultar: {
      type: Boolean,
      required: true
    },
    puedeCrear: {
      type: Boolean,
      required: true
    },
    puedeEditar: {
      type: Boolean,
      required: true
    },
    puedeAnular: {
      type: Boolean,
      required: true
    },
    administraTodasBodegas: {
      type: Boolean,
      required: true
    },
    idBodegaUsuario: {
      required: true
    }
  },
  data: function () {
    return {
      path: `${url}/egreso-bodega/consultar/C`,
      selectedBodega: null,
      egresoBodegaId: null,
      documento: null,
      optionsBodegas: [],
      form: {
        tipoFechaP: 'P',
        fechaDesdeP: null,
        fechaHastaP: null,
        estadoP: 'A',
        bodegaIdP: '',
        searchP: ''
      }
    }
  },
  methods: {
    validarFiltros: function () {
      if ((this.form.fechaDesdeP == null || this.form.fechaHastaP == null) && this.form.tipoFechaP == 'P') {
        swal('Debe seleccionar las fechas', 'Aviso', 'warning');
        return false;
      }
      return true;
    },
    inputBodega: function () {
      this.form.bodegaIdP = '';
      if (this.selectedBodega != null)
        this.form.bodegaIdP = this.selectedBodega.id;
    },
    consultar: function () {
      if (!this.validarFiltros())
        return;
      this.$refs.listaEgresos.loadRows();
    },
    crear: function () {
      this.egresoBodegaId = null;
      this.documento = null;
      this.$modal.show('egreso-bodega');
    },
    editar: function (row) {
      this.egresoBodegaId = row.id;
      this.documento = row.tipo_documento + '-' + row.numero_documento;
      this.$modal.show('egreso-bodega');
    },
    eliminar: function (row) {
      swal({
        title: `¿Desea ${row.estado == 'A' ? 'anular' : 'reactivar'} el egreso ${row.tipo_documento}-${row.numero_documento}?`,
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlApi = `${url}/egreso-bodega/anular/${row.id}`;
          axios
            .post(urlApi)
            .then(response => {
              let nuevoEstado = response.data.nuevo_estado;
              swal(
                'Realizado',
                `El egreso ${row.tipo_documento}-${row.numero_documento} ha sido ${nuevoEstado == 'A' ? 'reactivado' : 'anulado'}`,
                'success'
              );
              this.consultar();
            })
            .catch(error => {
              swal('Error', 'No se pudo realizar la operación', 'error');
            });
        }
      });
    }
  },
  mounted: function () {
    let desde = new Date();
    desde.setDate(desde.getDate() - 6);
    let hasta = new Date();
    this.form.fechaDesdeP = moment(desde).format("YYYY-MM-DD") + ' 00:00:00';
    this.form.fechaHastaP = moment(hasta).format("YYYY-MM-DD") + ' 23:59:59';
    if (this.administraTodasBodegas)
      this.optionsBodegas = [...this.bodegas];
    else {
      for (let i = 0; i < this.bodegas.length; i++) {
        if (this.idBodegaUsuario == this.bodegas[i].id) {
          this.optionsBodegas.push(this.bodegas[i]);
          this.selectedBodega = this.bodegas[i];
          this.form.bodegaIdP = this.bodegas[i].id;
          break;
        }
      }
    }
    this.consultar();
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/EgresosBodegas.vue